var click_el, myDropdown;
var scrollListener = function(e) {
    myDropdown.hide();
    document.removeEventListener('scroll', scrollListener, true);
};

document.querySelectorAll('[data-scroll-toggle="dropdown"]').forEach((item) => {
  item.addEventListener('click', (event) => {
      click_el = event.target.closest('[data-bs-toggle="dropdown"]');
      // console.log('cick event target ' + '= ' + event.target.closest('[data-bs-toggle="dropdown"]').classList);
      myDropdown = new bootstrap.Dropdown(click_el);
      document.addEventListener('scroll', scrollListener, true);
  });
});

// // // Based on https://www.html5rocks.com/en/tutorials/speed/animations/#debouncing-scroll-events

// var latestKnownScrollY = 0,
// 	ticking = false,
//     item = document.querySelectorAll('.item');


// function update() {
// 	// reset the tick so we can capture the next onScroll
// 	ticking = false;
//     console.log('scrolling');
//     console.log(myMenu);
//     myMenu.classList.remove('show');
//     window.removeEventListener('scroll', onScroll, false);
// }


// function onScroll() {
// 	latestKnownScrollY = window.scrollY; //No IE8
// 	requestTick();
// }

// function requestTick() {
// 	if(!ticking) {
// 		requestAnimationFrame(update);
// 	}
// 	ticking = true;
// }


// // // const button = document.querySelector('.button')
// // // class MyClass {
// // //    constructor(arg) {
// // //       this.boundEventHandler = this.eventHandler.bind(this, arg)
// // //       button.addEventListener('click', this.boundEventHandler)
// // //    }
// // // eventHandler(arg) {
// // //       console.log('button')
// // //    }
// // // removeListener() {
// // //       button.removeEventListener('click', this.boundEventHandler)
// // //    }
// // // }

// // const button = document.querySelector('.button');
// // button.addEventListener('click', this.boundEventHandler)

// // window.addEventListener('scroll', onScroll, false);
// var myMenu = '';

// function onClick() {
//     console.log('click');
//     myMenu = this.querySelector('.dropdown-menu');
//     window.addEventListener('scroll', onScroll, false);
// }

// function removeShow(selector) {
//     console.log('scroll');
//     console.log(selector);
//     selector.classList.remove('show');
// 	window.removeEventListener('scroll', onScroll, false);
// }

// var myDropdown = document.querySelector('.dropdown');
// myDropdown.addEventListener('click', onClick);
// // myCollapsible.addEventListener('hidden.bs.collapse', function () {
// //   console.log('collapse');
// // })

// $('#menu-mobile').on('show.bs.collapse', function () {
//     console.log('collapse event');
//   });